import React from "react";

const Spinner = () => {
  return (
    <div
      style={{
        position: "absolute",
        backdropFilter: "blur(2px)",
        top: 0,
        width: "100%",
        height: "100vh",
        left: 0,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        paddingBottom: '100px'
      }}
    >
      <div className="spinner-border text-primary" role="status">
        <span className="visually-hidden">Loading...</span>
      </div>
    </div>
  );
};

export default Spinner;
